export const res = {
  loginWithApp: {
    is: 'Innskrá með appinu',
    en: 'Login with the app',
    pl: 'Zaloguj się aplikacją bankową',
  } as const,
};
